export default __webpack_public_path__ + "6e63bd22128f27b83f228bf5ef541156.woff2";